import angular from 'angular';

function RevenueStatisticalService(REVENUE_PERIODS) {
    const getRevenueSum = (period, revenues) => {
        const revenuesStatisticsProcessorResolver = getRevenuesStatisticsProcessorResolver();
        const revenuesStatisticsProcessor = revenuesStatisticsProcessorResolver[period];

        if (revenuesStatisticsProcessor) {
            return revenuesStatisticsProcessor(revenues);
        }

        throw new Error(`Can't find 'revenuesProcessor' for this period: '${period}'`);
    };

    const getRevenuesStatisticsProcessorResolver = () => ({
        [REVENUE_PERIODS.LAST_12_MONTH]: getRevenueSumByLast12Month,
        [REVENUE_PERIODS.CURRENT_MONTH]: getRevenueSumByCurrentMonth,
        [REVENUE_PERIODS.CURRENT_QUARTER]: getRevenueSumByCurrentQuarter,
        [REVENUE_PERIODS.CURRENT_YEAR]: getRevenueSumByCurrentYear,
    });

    const getRevenueSumByLast12Month = (revenues) => {
        const revenuesByLast12Month = getRevenuesByLast12Month(revenues);

        return getSum(revenuesByLast12Month);
    };

    const getRevenueSumByCurrentMonth = (revenues) => {
        const currentMonth = (new Date()).getMonth();
        const revenuesByCurrentYear = getRevenuesByCurrentYear(revenues);
        const currentMonthRevenue = (revenuesByCurrentYear || []).filter(({ date }) => {
            const revenueDate = new Date(date).getMonth();

            return revenueDate === currentMonth;
        });

        return getSum(currentMonthRevenue);
    };

    const getRevenueSumByCurrentQuarter = (revenues) => {
        const revenueByCurrentQuarter = getRevenuesByCurrentQuarter(revenues);

        return getSum(revenueByCurrentQuarter);
    };

    const getRevenueSumByCurrentYear = (revenues) => {
        const revenueByCurrentYear = getRevenuesByCurrentYear(revenues);

        return getSum(revenueByCurrentYear);
    };

    const getRevenuesByLast12Month = (revenues) => {
        const last12Month = getLast12Month();

        return (revenues || []).filter(({ date }) => {
            const revenueDate = new Date(date);
            const revenueYear = revenueDate.getFullYear();
            const revenueMonth = revenueDate.getMonth();

            return last12Month.find((date) => {
                const isSameYear = date.getFullYear() === revenueYear;
                const isSameMonth = date.getMonth() === revenueMonth;

                return isSameYear && isSameMonth;
            });
        });
    };

    const getRevenuesByCurrentQuarter = (revenues) => {
        const currentDate = new Date();
        const currentQuarter = getQuarter(currentDate);
        const revenuesByCurrentYear = getRevenuesByCurrentYear(revenues);

        return (revenuesByCurrentYear || []).filter(({ date }) => {
            const revenueQuarter = getQuarter(new Date(date));

            return revenueQuarter === currentQuarter;
        });
    };

    const getRevenuesByCurrentYear = (revenues) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        return (revenues || []).filter(({ date }) => {
            const revenueDate = new Date(date);
            const isSameYear = currentYear === revenueDate.getFullYear();
            const isCurrentDateLaterRevenueDate = currentDate >= revenueDate;

            return isSameYear && isCurrentDateLaterRevenueDate;
        });
    };

    const getSum = revenues => (revenues || []).reduce((prevValue, { current }) => prevValue + current, 0);

    const getLast12Month = () => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();
        const last12Month = [];

        for (let month = currentMonth; month > currentMonth - 12; month--) {
            const date = new Date();

            if (month < 0) {
                date.setMonth(12 + month);
                date.setFullYear(currentYear - 1);
            } else {
                date.setMonth(month);
            }

            last12Month.push(date);
        }

        return last12Month;
    };

    const getQuarter = (currentDate) => {
        const quarterNumbers = [1, 2, 3, 4];

        return quarterNumbers[Math.floor(currentDate.getMonth() / 3)];
    };

    return {
        getRevenueSum,
        getRevenuesByLast12Month,
    };
}

angular
    .module('TALENYA-FE')
    .factory('RevenueStatisticalService', RevenueStatisticalService);
